import React from "react";
import { Typography } from "antd";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import styled from "styled-components";
const { Title } = Typography;
const StyledTitle = styled(Title)`
  margin-bottom: 0px !important;
  width: 100%;
`;
interface TitleAntdComponentIF {
  title: string;
  level: 1 | 2 | 3 | 4 | 5;
  mbLevel: 1 | 2 | 3 | 4 | 5;
}
const TitleAntdComponent = ({
  title,
  level = 4,
  mbLevel = 2,
}: TitleAntdComponentIF) => {
  const { screen }: any = useWindowSize();
  return (
    <StyledTitle level={["xxl", "xl", "lg"].includes(screen) ? level : mbLevel}>
      {title}
    </StyledTitle>
  );
};

export default TitleAntdComponent;
